import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout, { Container } from "../components/layout";
import { apiurl } from "../config/config";
import {
  FaFileExcel,
  FaFilter,
  FaPlus,
  FaSearch,
  FaUserCheck,
} from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as XLSX from "xlsx";
import { motion } from "framer-motion";
import { IoMdClose } from "react-icons/io";
import { SuwasthiLoader } from "../components/loader";
import Pagination from "../components/pagination";
import AssignRoleModal from "../components/assignRoleModal";
import Breadcrumb from "../components/breadcrumb";
import { useUser } from "../config/userProvider";
import { hasPermission } from "../config/permissions";

const Applications = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [assignModal, setAssignModal] = useState(false);
  const [selectedApp, setSelectedApp] = useState(null);
  const [role, setRole] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedApplications, setSelectedApplications] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [paginationData, setPaginationData] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const [filterStatus, setFilterStatus] = useState("");
  const [filterModalOpen, setFilterModalOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    fetchApplications();
  }, [currentPage, itemsPerPage]);

  const fetchApplications = () => {
    setLoading(true);
    fetch(
      `${apiurl}/api/application/get?page=${currentPage}&limit=${itemsPerPage}`
    )
      .then((res) => res.json())
      .then((data) => {
        setApplications(data.applications);
        setTotalItems(data.pagination?.totalItems || 0);
        setTotalPages(data.totalPages);
        setLoading(false);
        setPaginationData(data?.pagination);
        setSelectAll(false);
        setSelectedApplications([]);
      })
      .catch((err) => {
        console.error("Error fetching applications:", err);
        setLoading(false);
      });
  };

  const handleAssign = (app) => {
    setSelectedApp(app);
    setAssignModal(true);
  };

  const handleView = async (appId, isRead) => {
    if (!isRead) {
      await fetch(`${apiurl}/api/application/read-status`, {
        method: "PATCH",
        body: JSON.stringify({ applicationObjId: appId, isRead: true }),
        headers: { "Content-Type": "application/json" },
      });

      setApplications((prev) =>
        prev.map((app) => (app._id === appId ? { ...app, isRead: true } : app))
      );
    }
    navigate(`/applications/${appId}`);
  };

  const filteredApps = applications.filter((app) => {
    const nameMatch =
      app?.candidateSnapshot?.firstName
        ?.toLowerCase()
        .includes(search.toLowerCase()) ||
      app?.candidateSnapshot?.lastName
        ?.toLowerCase()
        .includes(search.toLowerCase());
    const emailMatch = app?.candidateSnapshot?.email
      ?.toLowerCase()
      .includes(search.toLowerCase());
    return nameMatch || emailMatch;
  });

  const listVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: { delay: index * 0.1, duration: 0.4 },
    }),
  };

  const handleLimitChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setPage(1);
  };

  useEffect(() => {
    setTotalPages(Math.ceil(totalItems / itemsPerPage) || 1);
  }, [totalItems, itemsPerPage]);

  const handleCheckboxChange = (appId) => {
    setSelectedApplications((prevSelected) =>
      prevSelected.includes(appId)
        ? prevSelected.filter((id) => id !== appId)
        : [...prevSelected, appId]
    );
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedApplications([]);
    } else {
      setSelectedApplications(applications.map((app) => app._id));
    }
    setSelectAll(!selectAll);
  };

  console.log("selectedApplications", selectedApplications);

  // const exportToExcel = () => {
  //   let dataToExport = applications;

  //   // Apply date filter if selected
  //   // if (startDate && endDate) {
  //   //   dataToExport = dataToExport.filter((emp) => {
  //   //     const empDate = new Date(emp.createdAt);
  //   //     return empDate >= startDate && empDate <= endDate;
  //   //   });
  //   // }

  //   // Apply selected employees filter
  //   if (selectedApplications.length > 0) {
  //     dataToExport = dataToExport.filter((emp) =>
  //       selectedApplications.includes(emp._id)
  //     );
  //   }

  //   if (dataToExport.length === 0) {
  //     alert("No employee data found for export.");
  //     return;
  //   }

  //   // Function to flatten employee data
  //   const flattenEmployeeData = (emp, index) => {
  //     const flattened = {
  //       SN: index+1 || "",
  //       Name: `${emp.candidateSnapshot.firstName} ${emp.candidateSnapshot.lastName}` || "",
  //       Designation: emp.positionTitle || "",
  //       Department: emp.department || "",
  //       Reference: emp.referenceDetails?.reference || "",
  //       Phone: emp.candidateSnapshot.phone || "",
  //       Email: emp.candidateSnapshot.email || "",
  //       Month : emp.interviewDetails?.interviewDate
  //         ? new Date(emp.interviewDetails.interviewDate.$date).toLocaleString("default", { month: "long" })
  //         : "",
  //       Year : emp.interviewDetails?.interviewDate
  //         ? new Date(emp.interviewDetails.interviewDate.$date).getFullYear()
  //         : "",
  //       "Interview Date": emp.interviewDetails?.interviewDate
  //         ? new Date(emp.interviewDetails.interviewDate.$date).toLocaleDateString()
  //         : "",
  //       "Interview Status": emp.applicationStatus || "",
  //       "Interview Remarks": emp.interviewDetails?.interviewFeedback || "",
  //       Exprince : emp.experience || "",
  //       "Expected Salary": emp.expectedSalary || "",
  //       "Offer Salary": emp.currentCTC || "",
  //       "Joinig Mail Status" : emp.joiningMailStatus || "",
  //     };

  //     return flattened;
  //   };

  //   // Map over the data and flatten
  //   const formattedData = dataToExport.map(flattenEmployeeData);

  //   const worksheet = XLSX.utils.json_to_sheet(formattedData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Applications");
  //   XLSX.writeFile(workbook, "APPLICATIONS.xlsx");
  // };
  const normalizeId = (rawId) => {
    if (!rawId) return "";
    const match = rawId.toUpperCase().match(/(SUW)[\s\-]?(\d+)/);
    return match ? `${match[1]}${match[2]}` : rawId.toUpperCase();
  };

  const exportToExcel = () => {
    let dataToExport = applications;

    if (selectedApplications.length > 0) {
      dataToExport = dataToExport.filter((emp) =>
        selectedApplications.includes(emp._id)
      );
    }

    if (dataToExport.length === 0) {
      alert("No employee data found for export.");
      return;
    }

    const uppercase = (value) => {
      return typeof value === "string" ? value.toUpperCase() : value;
    };

    const capitalize = (value) => {
      return typeof value === "string"
        ? value
            .split(/(\s+)/) // split by spaces, keeping the separators
            .map((word) =>
              word.trim()
                ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                : word
            )
            .join("")
        : value;
    };

    const normalizeId = (rawId) => {
      if (!rawId) return "";
      const match = rawId.toUpperCase().match(/(SUW)[\s\-]?(\d+)/);
      return match ? `${match[1]}${match[2]}` : rawId.toUpperCase();
    };
    const maskPhone = (phone) => {
      if (!phone) return "";
      const strPhone = phone.toString();
      return strPhone.length > 4
        ? "*".repeat(strPhone.length - 4) + strPhone.slice(-4)
        : strPhone;
    };

    // ✅ Mask email → show only alternate characters before @
    const maskEmail = (email) => {
      if (!email || !email.includes("@")) return email || "";
      const [local, domain] = email.split("@");
      const maskedLocal = local
        .split("")
        .map((ch, idx) => (idx % 2 === 0 ? ch : "*"))
        .join("");
      return `${maskedLocal}@${domain}`;
    };

    const flattenEmployeeData = (emp, index) => {
      const refType = emp.referenceDetails?.referenceType;
      let referenceName = "";
      let referenceId = "";

      if (refType === "employee") {
        referenceName = `EMP-${emp.referenceDetails.employeeName || ""}`;
        // referenceId = `SUW-${emp.referenceDetails.employeeId || ""}`;
        referenceId = normalizeId(emp.referenceDetails.employeeId || "");
      } else if (refType === "recruiter") {
        referenceName = `HR-${emp.referenceDetails.recruiterName || ""}`;
        referenceId = `SUW-${emp.referenceDetails.recruiterId || ""}`;
      } else if (refType === "consultancy") {
        referenceName = `${emp.referenceDetails.consultancyReference || ""}`;
        referenceId = "Consultancy";
      } else if (refType === "other") {
        referenceName = `OTHER-${emp.referenceDetails.otherReference || ""}`;
        referenceId = "N/A";
      } else if (refType === "walkin") {
        referenceName = `WALKIN`;
        referenceId = "N/A";
      } else {
        referenceName = "N/A";
        referenceId = "N/A";
      }

      const interviewDate = emp.screeningDetails?.date;
      const joiningDate = emp.offerDetails?.joiningDate;
      const joiningMailSent = emp.offerDetails?.joiningMail?.status;
      const joiningMailDate = emp.offerDetails?.joiningMail?.date;

      const offeredCTC = emp.offerDetails?.offeredCTC
        ? `${emp.offerDetails.offeredCTC.toFixed(2)} LPA / ${(
            emp.offerDetails.offeredCTC / 12
          ).toFixed(2)} MONTHLY`
        : "";
      const monthlySalary = emp.offerDetails?.monthlySalary
        ? `${emp.offerDetails.monthlySalary.toLocaleString("en-IN")} MONTHLY`
        : "";

      return {
        SNO: index + 1,
        ID: capitalize(emp.id || ""),
        NAME: capitalize(
          `${emp.candidateSnapshot.firstName} ${emp.candidateSnapshot.lastName}` ||
            ""
        ),
        DESIGNATION: capitalize(emp.positionTitle || ""),
        DEPARTMENT: capitalize(emp.department || ""),
        "REFERENCE NAME": capitalize(referenceName),
        "REFERENCE ID": uppercase(referenceId),
        // "CONTACT NO": capitalize(emp.candidateSnapshot.phone || ""),
        // EMAIL: capitalize(emp.candidateSnapshot.email || ""),
        "CONTACT NO": maskPhone(emp.candidateSnapshot.phone || ""),
        EMAIL: maskEmail(emp.candidateSnapshot.email || ""),
        MONTH: interviewDate
          ? new Date(interviewDate)
              .toLocaleString("default", { month: "long" })
              .toUpperCase()
          : "",
        YEAR: interviewDate ? new Date(interviewDate).getFullYear() : "",
        "TOTAL EXPERIENCE": emp.professionalInfo.totalExperience || 0,
        "RELEVANT EXPERIENCE": emp.professionalInfo.relevantExperience || 0,
        "PREVIOUS COMPANY": capitalize(
          emp.professionalInfo.previousCompany || ""
        ),
        PROCESS: capitalize(emp.professionalInfo.process || ""),
        "REASON FOR LEAVING": capitalize(
          emp.professionalInfo.reasonForLeaving || ""
        ),
        "INTERVIEW DATE": interviewDate
          ? new Date(interviewDate).toLocaleDateString().toUpperCase()
          : "",
        "INTERVIEW STATUS": capitalize(emp.applicationStatus || ""),
        "INTERVIEW REMARKS": capitalize(emp.screeningDetails?.feedback || ""),
        "OFFERED SALARY": offeredCTC,
        "MONTHLY SALARY": monthlySalary,
        "JOINING MAIL STATUS": joiningMailSent ? "SENT" : "NOT SENT",
        "JOINING MAIL DATE": joiningMailDate
          ? new Date(joiningMailDate).toLocaleDateString().toUpperCase()
          : "",
        "DATE OF JOINING": joiningDate
          ? new Date(joiningDate).toLocaleDateString().toUpperCase()
          : "",
      };
    };

    const formattedData = dataToExport.map(flattenEmployeeData);

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "APPLICATIONS");

    const fileName = `APPLICATIONS_${
      new Date().toISOString().split("T")[0]
    }.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  // const fetchFilterApplications = () => {
  //   setLoading(true);
  //   let url = `${apiurl}/api/application/filter?page=${currentPage}&limit=${itemsPerPage}`;
  //   // let url = `${apiurl}api/application/filter?startDate=2025-04-22&endDate=2025-04-22&applicationStatus=applied&page=1&limit=50`;

  //   if (startDate) url += `&startDate=${startDate.toISOString()}`;
  //   if (endDate) url += `&endDate=${endDate.toISOString()}`;
  //   if (filterStatus) url += `&applicationStatus=${filterStatus}`;

  //   fetch(url)
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setApplications(data.applications);
  //       setTotalItems(data.pagination?.totalItems || 0);
  //       setTotalPages(data.totalPages);
  //       setLoading(false);
  //       setPaginationData(data?.pagination);
  //       setSelectAll(false);
  //       setSelectedApplications([]);
  //     })
  //     .catch((err) => {
  //       console.error("Error fetching applications:", err);
  //       setLoading(false);
  //     });
  // };

  // const fetchFilterApplications = () => {
  //   setLoading(true);
  //   let url = `${apiurl}/api/application/filter?page=${currentPage}&limit=${itemsPerPage}`;

  //   const formatDate = (date) => {
  //     const day = String(date.getDate()).padStart(2, "0");
  //     const month = String(date.getMonth() + 1).padStart(2, "0");
  //     const year = date.getFullYear();
  //     return `${year}-${month}-${day}`;
  //   };

  //   if (startDate) url += `&startDate=${formatDate(startDate)}`;
  //   if (endDate) url += `&endDate=${formatDate(endDate)}`;
  //   if (filterStatus) url += `&applicationStatus=${filterStatus}`;

  //   fetch(url)
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setApplications(data.applications);
  //       setTotalItems(data.pagination?.totalItems || 0);
  //       setTotalPages(data.totalPages);
  //       setLoading(false);
  //       setPaginationData(data?.pagination);
  //       setSelectAll(false);
  //       setSelectedApplications([]);
  //     })
  //     .catch((err) => {
  //       console.error("Error fetching applications:", err);
  //       setLoading(false);
  //     });
  // };

  const fetchFilterApplications = () => {
    setLoading(true);

    const formatDate = (date) => {
      if (!date) return "";
      const d = new Date(date);
      return d.toLocaleDateString("en-CA"); // "YYYY-MM-DD" in local time
    };

    const params = new URLSearchParams();
    params.append("page", currentPage);
    params.append("limit", itemsPerPage);

    // if (startDate) {
    //   params.append("startDate", startDate.toISOString().split("T")[0]); // yyyy-mm-dd
    // }

    // if (endDate) {
    //   params.append("endDate", endDate.toISOString().split("T")[0]);
    // }

    if (startDate) {
      params.append("startDate", formatDate(startDate));
    }

    if (endDate) {
      params.append("endDate", formatDate(endDate));
    }

    if (filterStatus) {
      params.append("applicationStatus", filterStatus);
    }

    // Optional: If you want to support search/filter by name/email/phone etc.
    if (search) {
      params.append("search", search);
    }

    fetch(`${apiurl}/api/application/filter?${params.toString()}`)
      .then((res) => res.json())
      .then((data) => {
        setApplications(data.applications);
        setTotalItems(data.pagination?.totalItems || 0);
        setTotalPages(data.totalPages || 0);
        setPaginationData(data.pagination || {});
        setSelectedApplications([]);
        setSelectAll(false);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching applications:", err);
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchFilterApplications();
  }, [currentPage, itemsPerPage, search, startDate, endDate, filterStatus]);

  let { userData } = useUser();

  const hasReadPermission = (permissions, resourceKey) => {
    const perm = permissions?.find((p) => p.resource === resourceKey);
    return perm?.read === true;
  };

    if(userData?.role === 'recruiter'){
    navigate('/recruiter/dashboard'); 
  }

  return (
    <Layout>
      {/* <Breadcrumb/> */}
      <Container overflow={"overflow-scroll"}>
        <div className="p-2 bg-gray-100 ">
          {/* <h2 className="text-2xl font-semibold mb-4">Application List</h2> */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-3">
            {/* Search Input */}
            <div className="flex items-center gap-2 w-full md:w-1/3">
              {/* <FaSearch className="text-gray-400" /> */}
              {/* <input
                type="text"
                placeholder="Search by name or email"
                className="p-2 border rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              /> */}
              <input
                type="text"
                placeholder="Search by name, email, id, or aadhar"
                className="p-2 border rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={search}
                onChange={(e) => {
                  const value = e.target.value;
                  // ✅ Allow only letters and numbers
                  if (/^[a-zA-Z0-9]*$/.test(value)) {
                    setSearch(value);
                  }
                }}
              />
            </div>

            {/* Action Buttons */}
            <div className="flex flex-wrap gap-2 justify-start md:justify-end items-center w-full md:w-auto">
              {hasReadPermission(
                userData.permissions,
                "download_applications"
              ) && (
                <button
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-white bg-green-500 hover:bg-green-600 transition ${
                    selectedApplications.length === 0
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                  }`}
                  onClick={exportToExcel}
                  disabled={selectedApplications.length === 0}
                >
                  <FaFileExcel />{" "}
                  {selectedApplications.length === 0
                    ? "Download Excel"
                    : `Download Excel (${selectedApplications.length})`}
                </button>
              )}
              <select
                className="p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={itemsPerPage}
                onChange={handleLimitChange}
              >
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="500">500</option>
                <option value="500">500</option>
                <option value="1000">1000</option>
                <option value="2000">2000</option>
                <option value="3000">3000</option>
                <option value="5000">5000</option>
              </select>

              {selectedApplications.length > 0 && (
                <button
                  className="flex items-center gap-2 px-4 py-2 rounded-lg text-white bg-red-500 hover:bg-red-600 transition"
                  onClick={() => setIsModalOpen(true)}
                >
                  <FaUserCheck /> Assign
                </button>
              )}

              <button
                onClick={() => setFilterModalOpen(true)}
                className="flex items-center gap-2 px-4 py-2 rounded-lg text-white bg-blue-500 hover:bg-blue-600 transition"
              >
                <FaFilter /> Filter
              </button>

              <Link
                to="/application-form"
                className="flex items-center gap-2 px-4 py-2 rounded-lg text-white bg-indigo-500 hover:bg-indigo-600 transition"
              >
                <FaPlus /> Add Application
              </Link>
            </div>
          </div>

          {loading ? (
            <SuwasthiLoader />
          ) : (
            <div className="bg-white shadow-md rounded-lg p-4 overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="p-3">
                      <input
                        className="w-4 h-4"
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th className="p-3 text-left">Application ID</th>
                    <th className="p-3 text-left">Name</th>
                    <th className="p-3 text-left">Email</th>
                    <th className="p-3 text-left">Status</th>
                    <th className="p-3 text-left">Position</th>
                    <th className="p-3 text-left">Location</th>
                    <th className="p-3 text-left">Reference</th>
                    <th className="p-3 text-left">Screening</th>
                    <th className="p-3 text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {/* {filteredApps.map((app) => (
                    <tr key={app._id} className={`border-b ${!app.isRead ? "bg-yellow-100" : ""}`}>
                      <td className="p-3 flex items-center gap-2">
                        {app.isNewApplicant && <span className="bg-green-500 text-white px-2 py-1 text-xs rounded">New</span>}
                        {app?.id}
                      </td>
                      <td className="p-3">{app?.candidateSnapshot?.firstName} {app?.candidateSnapshot?.lastName}</td>
                      <td className="p-3">{app.candidateSnapshot?.email}</td>
                      <td className="p-3">{app.applicationStatus}</td>
                      <td className="p-3 flex gap-2">
                        <button className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600" onClick={() => handleView(app._id)}>View</button>
                        <button className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600" onClick={() => setIsModalOpen(true)}>Assign</button>
                      </td>
                    </tr>
                  ))} */}

                  {filteredApps.map((app, index) => (
                    <motion.tr
                      key={app._id}
                      className={`border-b ${
                        !app.isRead ? "bg-yellow-100" : ""
                      }`}
                      variants={listVariants}
                      initial="hidden"
                      animate="visible"
                      custom={index}
                    >
                      <td className="p-3">
                        <input
                          type="checkbox"
                          className="text-[16px] w-4 h-4"
                          checked={selectedApplications.includes(app._id)}
                          onChange={() => handleCheckboxChange(app._id)}
                        />
                      </td>
                      <td className="p-3 flex items-center gap-2">
                        {(() => {
                          const createdDate = new Date(app.createdAt);
                          const today = new Date();

                          const isToday =
                            createdDate.getDate() === today.getDate() &&
                            createdDate.getMonth() === today.getMonth() &&
                            createdDate.getFullYear() === today.getFullYear();

                          return isToday ? (
                            <motion.span
                              className="bg-green-500 text-white px-2 py-1 rounded text-[10px]"
                              initial={{ scale: 0 }}
                              animate={{ scale: 1 }}
                              transition={{ type: "spring", stiffness: 200 }}
                            >
                              New
                            </motion.span>
                          ) : null;
                        })()}


                          {/* 🚫 BLOCKED FLAG */}
  {app?.candidateSnapshot?.isBlocked && (
    <span
      className="bg-red-600 text-white px-2 py-1 rounded text-[10px] font-semibold"
      title={app.candidateSnapshot?.blockedReason || "Candidate is blocked"}
    >
      BLACKLISTED
    </span>
  )}
                        <span className="text-[12px]">{app?.id}</span>
                      </td>
                      <td className="p-2 text-[12px]">
                        {app?.candidateSnapshot?.firstName}{" "}
                        {app?.candidateSnapshot?.lastName}
                      </td>
                      <td className="p-2 text-[12px]">
                        {app.candidateSnapshot?.email}
                      </td>
                      {/* <td className="p-2 text-[12px]">{app.applicationStatus}</td> */}
                      <td className="p-2 text-[12px]">
                        {(() => {
                          const status = app.applicationStatus?.toLowerCase();
                          let colorClasses = "";
                          let label = app.applicationStatus || "Unknown";

                          switch (status) {
                            case "applied":
                              colorClasses =
                                "bg-green-100 text-green-700 border-green-300";
                              break;

                            case "shortlisted":
                              colorClasses =
                                "bg-blue-100 text-blue-700 border-blue-300";
                              break;

                            case "screening":
                              colorClasses =
                                "bg-cyan-100 text-cyan-700 border-cyan-300";
                              break;

                            case "interviewing":
                            case "interview":
                              colorClasses =
                                "bg-indigo-100 text-indigo-700 border-indigo-300";
                              break;

                            case "selected":
                              colorClasses =
                                "bg-emerald-100 text-emerald-700 border-emerald-300";
                              break;

                            case "offered":
                              colorClasses =
                                "bg-sky-100 text-sky-700 border-sky-300";
                              break;

                            case "not joined":
                            case "not-joined":
                              colorClasses =
                                "bg-orange-100 text-orange-700 border-orange-300";
                              break;

                            case "joined":
                              colorClasses =
                                "bg-teal-100 text-teal-700 border-teal-300";
                              break;

                            case "training":
                              colorClasses =
                                "bg-violet-100 text-violet-700 border-violet-300";
                              break;

                            case "onboarding":
                              colorClasses =
                                "bg-blue-100 text-blue-700 border-blue-300";
                              break;

                            case "hired":
                              colorClasses =
                                "bg-green-200 text-green-800 border-green-400";
                              break;

                            case "rejected":
                              colorClasses =
                                "bg-red-100 text-red-700 border-red-300";
                              break;

                            case "on hold":
                            case "on-hold":
                              colorClasses =
                                "bg-yellow-100 text-yellow-700 border-yellow-300";
                              break;

                            case "abscond":
                              colorClasses =
                                "bg-gray-200 text-gray-700 border-gray-300";
                              break;

                            default:
                              colorClasses =
                                "bg-gray-100 text-gray-600 border-gray-300";
                              break;
                          }

                          return (
                            <span
                              className={`px-2 py-1 border rounded-full text-[11px] font-medium capitalize tracking-wide ${colorClasses}`}
                            >
                              {label}
                            </span>
                          );
                        })()}
                      </td>

                      <td className="p-2 text-[12px]">{app.positionTitle}</td>
                      <td className="p-2 text-[12px]">{app.location}</td>
                      <td className="p-2 text-[12px]">
                        {(() => {
                          const refType = app.referenceDetails?.referenceType;
                          let referenceName = "";
                          let referenceId = "";

                          if (refType === "employee") {
                            referenceName = `EMP-${
                              app.referenceDetails.employeeName || ""
                            }`;
                            referenceId = normalizeId(
                              app.referenceDetails.employeeId || ""
                            );
                          } else if (refType === "recruiter") {
                            referenceName = `HR-${
                              app.referenceDetails.recruiterName || ""
                            }`;
                            referenceId = `SUW-${
                              app.referenceDetails.recruiterId || ""
                            }`;
                          } else if (refType === "consultancy") {
                            referenceName = `${
                              app.referenceDetails.consultancyReference || ""
                            }`;
                            referenceId = "Consultancy";
                          } else if (refType === "other") {
                            referenceName = `OTHER-${
                              app.referenceDetails.otherReference || ""
                            }`;
                            referenceId = "N/A";
                          } else if (refType === "walkin") {
                            referenceName = `WALKIN`;
                            referenceId = "N/A";
                          } else {
                            referenceName = "N/A";
                            referenceId = "N/A";
                          }

                          // Return JSX
                          return (
                            <div className="flex flex-col text-gray-700">
                              <span className="font-medium">
                                {referenceName}
                              </span>
                              <span className="text-gray-500 text-[11px]">
                                {referenceId}
                              </span>
                            </div>
                          );
                        })()}
                      </td>
                      <td>
                                                <div className="flex flex-col text-gray-700">
                              <span className="font-medium text-[12px] capitalize">
                 {app.screeningDetails?.screenerName || "N/A"}
                              </span>
                              <span className="text-gray-500 text-[11px]">
                           {app.screeningDetails?.date ? new Date(app.screeningDetails.date).toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }) : "N/A"}
                              </span>
                            </div>
                      </td>

                      <td className="p-2 flex gap-2">
                        {hasPermission(
                          userData.permissions,
                          "application",
                          "read"
                        ) && (
                          <button
                            className="bg-green-500 text-[12px] text-white px-3 py-1 rounded hover:green-blue-600"
                            whileHover={{ scale: 1.1 }}
                            onClick={() => handleView(app._id, app.isRead)}
                          >
                            View
                          </button>
                        )}
                        {hasPermission(
                          userData.permissions,
                          "application",
                          "write"
                        ) && (
                          <Link
                            className="bg-blue-500 text-white px-2 py-1 text-[12px] rounded hover:bg-blue-600"
                            whileHover={{ scale: 1.1 }}
                            to={`/applications/${app._id}/manage`}
                          >
                            Manage
                          </Link>
                        )}
                      </td>
                    </motion.tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {isModalOpen && (
          <AssignRoleModal
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            selectedApplications={selectedApplications}
          />
        )}

        {filterModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-xl">
              <h2 className="text-xl font-semibold mb-4">
                Filter Applications
              </h2>

              <div className="mb-4">
                <label className="block text-sm mb-1">Start Date:</label>
                <DatePicker
                  selected={startDate}
                  onChange={setStartDate}
                  placeholderText="Start Date"
                  className="p-2 border rounded w-full"
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm mb-1">End Date:</label>
                <DatePicker
                  selected={endDate}
                  onChange={setEndDate}
                  placeholderText="End Date"
                  className="p-2 border rounded w-full"
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm mb-1">Status:</label>
                <select
                  value={filterStatus}
                  onChange={(e) => setFilterStatus(e.target.value)}
                  className="p-2 border rounded w-full"
                >
                  <option value="">All</option>
                  <option value="applied">Applied</option>
                  <option value="interviewing">interviewing</option>
                  <option value="offered">Offered</option>
                  <option value="rejected">Rejected</option>
                  <option value="on-hold">On Hold</option>
                </select>
              </div>

              <div className="flex justify-end gap-2">
                <Link
                  to={
                    filterStatus.length > 0 || startDate || endDate
                      ? `/applications/advanced-search?applicationStatus=${filterStatus}&startDate=${startDate}&endDate=${endDate}`
                      : `/applications/advanced-search`
                  }
                  className="flex items-center gap-2 px-4 py-2 rounded-lg text-white bg-blue-500 hover:bg-blue-600 transition"
                >
                  <FaSearch /> Advanced Search
                </Link>

                <button
                  className="bg-gray-300 text-black px-4 py-2 rounded"
                  onClick={() => {
                    setStartDate(null);
                    setEndDate(null);
                    setFilterStatus("");
                    fetchApplications();
                  }}
                >
                  Clear Filters
                </button>

                <button
                  onClick={() => setFilterModalOpen(false)}
                  className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setFilterModalOpen(false);
                    fetchFilterApplications(); // you can also add filter logic here
                  }}
                  className="px-4 py-2 rounded bg-green-600 hover:bg-green-700 text-white"
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        )}

        <Pagination
          currentPage={currentPage}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </Container>
    </Layout>
  );
};

export default Applications;